import { createSelector } from '@reduxjs/toolkit';
import { LoadingStatus } from "../../../../shared/model";
import { getLastSession } from "../../../../shared/lib/utils";
import { ImgPreviewType } from "../../../../shared/types/settings";
import { checkIfLastSessionFinished } from "./utils";
var selectMessages = function selectMessages(state) {
  return state.message;
};
export var selectHistory = function selectHistory(state) {
  return selectMessages(state).history;
};
export var selectSessionsList = function selectSessionsList(state) {
  return selectHistory(state).list;
};
export var selectIsOnlySession = function selectIsOnlySession(state) {
  var _selectSessionsList;
  return ((_selectSessionsList = selectSessionsList(state)) === null || _selectSessionsList === void 0 ? void 0 : _selectSessionsList.length) === 1;
};
export var selectIsHistoryEmpty = function selectIsHistoryEmpty(state) {
  return !selectSessionsList(state).length;
};
export var selectLastSession = function selectLastSession(state) {
  var sessionSlice = selectMessages(state);
  return getLastSession(sessionSlice.history);
};
export var selectIsLastSessionFinished = function selectIsLastSessionFinished(state) {
  var lastSession = selectLastSession(state);
  return checkIfLastSessionFinished(lastSession);
};
export var selectResubmitMessages = function selectResubmitMessages(state) {
  return selectMessages(state).resubmitMessages;
};
/**
 * Флаг для отправки аналитики.
 * IsLSF - IsLastSessionFinished
 * true = закрыта сессия или чистая сессия(Empty).
 * */
export var selectIsLSFOrEmpty = function selectIsLSFOrEmpty(state) {
  var _selectSessionsList2;
  var isLastSession = selectIsLastSessionFinished(state);
  var isEmptyHistory = !((_selectSessionsList2 = selectSessionsList(state)) !== null && _selectSessionsList2 !== void 0 && _selectSessionsList2.length);
  return isLastSession || isEmptyHistory;
};
export var selectLoadingStatus = function selectLoadingStatus(state) {
  return selectMessages(state).status;
};
export var selectIsLoading = function selectIsLoading(state) {
  return selectLoadingStatus(state) === LoadingStatus.loading;
};
export var selectIsLoadStatusSuccess = function selectIsLoadStatusSuccess(state) {
  return selectLoadingStatus(state) === LoadingStatus.fulfilled;
};
export var selectIsError = function selectIsError(state) {
  return selectLoadingStatus(state) === LoadingStatus.failed;
};
export var selectIsIdle = function selectIsIdle(state) {
  return selectLoadingStatus(state) === LoadingStatus.idle;
};
export var selectResendMessageId = function selectResendMessageId(state) {
  return selectMessages(state).resendMessageId;
};
export var selectReplyMessage = function selectReplyMessage(state) {
  return selectMessages(state).replyMessage;
};
export var selectUnreadedMessages = function selectUnreadedMessages(state) {
  return selectMessages(state).unreadedMessages;
};
export var selectImgPreview = function selectImgPreview(state) {
  return selectMessages(state).imgPreview;
};
export var selectIsImgPreviewOpen = function selectIsImgPreviewOpen(state) {
  return selectImgPreview(state).isImgPreviewOpen;
};
export var selectImgPreviewType = function selectImgPreviewType(state) {
  return selectImgPreview(state).type;
};
export var selectImgPreviewTypeShow = function selectImgPreviewTypeShow(state) {
  return selectImgPreviewType(state) === ImgPreviewType.show;
};
export var selectImgPreviewTypeUpload = function selectImgPreviewTypeUpload(state) {
  return selectImgPreviewType(state) === ImgPreviewType.upload;
};
export var selectImgTypeUploadOpen = createSelector([selectIsImgPreviewOpen, selectImgPreviewTypeUpload], function (isOpen, imgPreviewTypeUpload) {
  return isOpen && imgPreviewTypeUpload;
});
export var selectContext = function selectContext(state) {
  return selectMessages(state).context;
};